import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../assets/css/auth.css';

const Register = () => {
  console.log('Register component rendering');
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [registrationStep, setRegistrationStep] = useState('initial'); // 'initial', 'loading', 'success'
  const { registerWithEmail } = useAuth();
  const navigate = useNavigate();

  // Debug-Logging für alle relevanten States
  useEffect(() => {
    console.log('State changed:', {
      showSuccess,
      loading,
      error,
      registrationStep
    });
  }, [showSuccess, loading, error, registrationStep]);

  const handleRegister = async (e) => {
    console.log('handleRegister called');
    e.preventDefault();
    if (loading) {
      console.log('Registration already in progress, returning');
      return;
    }
    
    if (password !== confirmPassword) {
      console.log('Passwords do not match');
      setError('Die Passwörter stimmen nicht überein');
      return;
    }

    console.log('Starting registration process...');
    setError('');
    setLoading(true);
    setRegistrationStep('loading');

    try {
      console.log('Calling registerWithEmail...');
      const userData = {
        email: email,
        farmId: null,
        farmName: '',
        createdAt: new Date().getTime(),
        role: 'user'
      };
      const result = await registerWithEmail(email, password, userData);
      console.log('Registration result:', result);
      
      if (result && result.success) {
        console.log('Registration successful, preparing success message');
        setSuccessMessage(result.message || 'Registrierung erfolgreich. Bitte bestätigen Sie Ihre E-Mail-Adresse.');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setRegistrationStep('success');
        setShowSuccess(true);
      } else {
        console.log('Registration failed:', result);
        setError(result?.error || result?.message || 'Registrierung fehlgeschlagen');
        setRegistrationStep('initial');
      }
    } catch (error) {
      console.error('Register error:', error);
      setError('Registrierung fehlgeschlagen: ' + error.message);
      setRegistrationStep('initial');
    } finally {
      setLoading(false);
    }
  };

  // Verhindere Re-Rendering durch Auth-State-Change
  useEffect(() => {
    if (registrationStep === 'success' && !showSuccess) {
      console.log('Restoring success state');
      setShowSuccess(true);
    }
  }, [registrationStep, showSuccess]);

  return (
    <div className="auth-page">
      {registrationStep === 'success' && showSuccess && (
        <div className="success-toast">
          <div className="success-toast-content">
            <div className="success-icon">✓</div>
            <p>{successMessage}</p>
            <button 
              onClick={() => {
                setShowSuccess(false);
                setRegistrationStep('initial');
                navigate('/login', { 
                  replace: true,
                  state: { fromRegistration: true }
                });
              }}
              className="auth-button primary"
            >
              Zum Login
            </button>
          </div>
        </div>
      )}

      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <div className="auth-logo-placeholder">
              <img src="assets/images/Logo3-01.png" alt="Hof-Portal Logo" />
            </div>
            <h1>Direkterzeuger-Portal</h1>
          </div>

          <div className="auth-methods">
            <div className="info-message">
              <i className="fas fa-info-circle"></i>
              <p>Hinweis: Nur die im Direkterzeuger-Profil hinterlegte E-Mail-Adresse kann registriert und freigeschaltet werden.</p>
            </div>

            <form id="registerForm" className="auth-form" onSubmit={handleRegister}>
              <div className="form-group">
                <label htmlFor="email">E-Mail</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Passwort</label>
                <input 
                  type="password" 
                  id="password" 
                  name="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Passwort bestätigen</label>
                <input 
                  type="password" 
                  id="confirmPassword" 
                  name="confirmPassword" 
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required 
                />
              </div>

              {error && <div className="error-message">{error}</div>}

              <button 
                type="submit" 
                className="auth-button primary"
                disabled={loading}
              >
                {loading ? 'Registrierung läuft...' : 'Registrieren'}
              </button>
            </form>

            <div className="auth-footer">
              <p>Bereits registriert? <Link to="/login">Zum Login</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register; 